import React, { useEffect, useMemo } from 'react';
import withDefaults from '../utils/with-defaults';
import { useTabsContext } from './tabs-context';
var defaultProps = {
  disabled: false
};

var TabsItem = function TabsItem(_ref) {
  var children = _ref.children,
      value = _ref.value,
      label = _ref.label,
      disabled = _ref.disabled;

  var _useTabsContext = useTabsContext(),
      register = _useTabsContext.register,
      currentValue = _useTabsContext.currentValue;

  var isActive = useMemo(function () {
    return currentValue === value;
  }, [currentValue, value]);
  useEffect(function () {
    register && register({
      value: value,
      label: label,
      disabled: disabled
    });
  }, [value, label, disabled]);
  /* eslint-disable react/jsx-no-useless-fragment */

  return isActive ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

export default withDefaults(TabsItem, defaultProps);
/* eslint-enable */